export default __webpack_public_path__ + "static/sphere-9fdd16b532964501d218bcd5a240118f.webp";